import http from '@/utils/http'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// 省列表
export function getProvinceList(params){
    return http.get('/businessType/area/listRoot', params)
}
// 市区列表
export function getCityList(params){
    return http.get('/businessType/area/listChild',params)
}

// 基地学校列表
export function getSchoolList(params){
    return http.get('/school/school/getSchoolPortalInfoList',params)
}
export function listSchoolAll(params){
    return http.get('/school/school/listAll',params)
}

// 基地学校详情
export function getSchoolDetail(id){
    return http.get('/school/school/portal/'+id)
}

// “2+2”教研反馈列表
export function getKuiList(params){
    return http.get('/videoBusiness/businessCommentsExpand/selectCommentsVideoList',params)
}
// “2+2”教研反馈详情
export function getKuiDetail(params){
    return http.get('/videoBusiness/businessCommentsExpand/portalList',params)
}
// 管理中心获取学校列表
export function getmanageSchool(params){
    return http.get('/school/school/getSchoolSelectListByAuthority',params)
}
// 管理中心获取学校列表搜索下拉列表
export function getmanageSchoolSelect(province,city,area,sid){
    return http.get('/school/school/getSchoolSelectList?provinces='+province+'&cities='+city+'&areas='+area+'&sids='+sid)
}
export function getscholloption(params){
    return http.get('/school/school/getSearchData',params)
}
export function tokelidetail(businessVideoId){
    return http.get('/videoBusiness/videoExpandadmin/schoolKeLi/'+businessVideoId)
}


// WEBPACK FOOTER //
// ./src/api/school.js